import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { markFormGroupTouched } from '../../../../general/utils';
import swal from 'sweetalert2';
import { NotasFiscaisComunicacaoService } from '../../../../services/notas-fiscais-comunicacao.service';
import { finalize } from 'rxjs/operators';
import { ModalBasicComponent } from '../../../../shared/modal-basic/modal-basic.component';
import * as moment from 'moment';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-notas-fiscais-comunicacao',
  templateUrl: './notas-fiscais-comunicacao.component.html',
  styleUrls: ['./notas-fiscais-comunicacao.component.css']
})
export class NotasFiscaisComunicacaoComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild("modalRelatorio", { static: true }) modalRelatorio: ModalBasicComponent;
  impressaoForm: FormGroup;
  @Output() closed: EventEmitter<any> = new EventEmitter();
  loading: boolean = false;

  constructor(private notasFiscaisComunicacaoService: NotasFiscaisComunicacaoService) { super() }

  ngOnInit() {
    this.impressaoForm = new FormGroup({
      inicio: new FormControl(moment().startOf('month').toDate(), [Validators.required]),
      fim: new FormControl(moment().endOf('month').startOf('day').toDate(), [Validators.required]),
      tipoImpressao: new FormControl('pdf', [Validators.required])
    })
  }

  get getTipoArquivo(): string {
    return this.impressaoForm.get('tipoImpressao').value;
  }

  destroyComponent() {
    this.closed.emit();
  }

  show(): void {
    this.modalRelatorio.show();
  }

  validaForm() {
    markFormGroupTouched(this.impressaoForm);
  }

  submitForm() {
    if (this.impressaoForm.valid) {
      this.loading = true;
      this.modalRelatorio.hide();
      this.notasFiscaisComunicacaoService.imprimirRelatorio(this.impressaoForm.value)
        .pipe(finalize(() => this.loading = false))
        .subscribe(res => {
          saveAs(res, `relatorio_nf_comunicacao.${this.getTipoArquivo}`);
          this.destroyComponent();
        }, (error) => {
          swal("Falha ao emitir o relatório: NF Comunicação", error.errors[0], "error");
          this.destroyComponent();
        })
    }
  }

}
